import { TableTherapyFundWalletsComponent } from '../../components/table-therapy-fund-wallets/table-therapy-fund-wallets.component';
import { ListPagerComponent } from '../../components/list-pager/list-pager.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';

@Component({
	standalone: true,
	selector: 'card-therapy-fund-wallets',
	templateUrl: './card-therapy-fund-wallets.component.html',
	imports: [ CommonModule, TableTherapyFundWalletsComponent, ListPagerComponent, FormsModule ]
})
export class CardTherapyFundWalletsComponent implements OnInit {
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() pageSize: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.wallets = [];
		this.vm.pageSize = 10;
	}

	currentPageChanged(newPage) {
		this.vm.currentPage = newPage;
		this.angularBroadcastHelperService.rootBroadcast("loadMorePages", newPage);
	}
	
}